.uui-input-search-button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    font-size: 1em;
}

.hide {
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    /* Using 'opacity: 0;' reserves space and breaks layout. */
}